import { emptyNull } from '../../../shared/misc';

const DEFAULT_URL_BASE = 'https://stats.virtual-meeting.net/';
const DEFAULT_TRACKER_URL = 'https://stats.virtual-meeting.net/matomo.php';

export default function applyDefaults(config = emptyNull) {
  const useExternalService = config.useExternalService ?? false;

  return {
    urlBase: useExternalService ? (config.urlBase ?? DEFAULT_URL_BASE) : DEFAULT_URL_BASE,
    trackerUrl: useExternalService ? (config.trackerUrl ?? DEFAULT_TRACKER_URL) : DEFAULT_TRACKER_URL,
    siteId: config.siteId ?? 42,
    configurations: {
      ...config.configurations,
      disableCookies: config.configurations?.disableCookies ?? true
    }
  };
}
